<template>
  <div class="departmentBox">
    <div class="searchBox">
      <div class="kernel">
        <div class="inputBox">
          <el-input placeholder="请输入关键词" v-model="keyword" @keyup.enter.native="handleSearch"></el-input>
        </div>
        <div class="searchButton" @click="handleSearch">
          查询
        </div>
      </div>
    </div>
    <div class="firstBox">
      <div class="circle"></div>
      <div class="text">所有单位</div>
    </div>
    <div class="secondBox">
      <change-tree :highlight-current="true" :data="treeData" :props="defaultProps" :default-expand-all="true" :filter-node-method="filterNode"
                   node-key="id" ref="changeTree" :current-node-key="currentId" @node-click="nodeClick"></change-tree>
    </div>
  </div>
</template>

<script>
import changeTree from '@/components/change-tree/src/tree'
import Vue from "vue";

export default {
  name: "department",
  components: {
    changeTree
  },
  data() {
    return {
      keyword:'',
      treeData: [],
      dataContainer:[],
      defaultProps: {
        children: 'children',
        label: 'title'
      },
      currentId: '',
      parentId: '',
      allItem: []
    }
  },
  created() {
    this.getTreeData()
    this.currentId = JSON.parse(localStorage.userInfo).deptId
  },
  mounted() {

  },
  methods: {
    filterNode(value, data) {
      console.log('吕布')
      console.log(data)
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    handleSearch(){
      this.$refs.changeTree.filter(this.keyword)
    },
    getParentId(currentId) {
      let flag = false
      let id = ""
      this.allItem.forEach(item => {
        if (item.id == currentId) {
          flag = true
          id = item.parentId
          this.parentId = item.id
        }
      })
      if (flag) {
        this.getParentId(id)
      }
    },
    getTreeData() {
      this.$request({
        method: 'get',
        url: '/platform/screen/dept/tree'
      }).then(res => {
        this.treeData = res.data.result
        this.dataContainer = res.data.result
        // this.getAllItem(res.data.result[0])
        // this.getParentId(this.currentId)
      })
    },
    compareParentId(node) {
      if (node.parent) {
        this.compareParentId(node.parent)
      } else {
        if (node.data.id == this.parentId) {
          return true
        } else {
          return false
        }
      }
    },
    getAllItem(treeData) {
      if (treeData.children) {
        treeData.children.forEach(item => {
          this.allItem.push(item)
          if (item.children) {
            this.getAllItem(item)
          }
        })
      }
    },
    nodeClick(obj, node, com) {
      // console.log(obj)
      // return
      const deptId = JSON.parse(localStorage.getItem('userInfo')).deptId
      if(obj.id == deptId){
        const jumpUrl = 'https://jxxuqiuce.com/'
        const str = window.location.href.split('/')[window.location.href.split('/').length-1]
        const id = JSON.parse(localStorage.getItem('userInfo')).username
        if(str === 'WaterAndElectricityManagement'){
          // window.location.href = jumpUrl+`sd/system/login?id=${id}`
          window.open(jumpUrl+`sd/system/login?id=${id}`)
        }
        if(str === 'OperationMaintenance'){
          // window.location.href = jumpUrl+`yw/system/login?id=${id}`
          window.open(jumpUrl+`yw/system/login?id=${id}`)
        }
        if(str === 'AirConditioningManagement'){
          window.open(' http://121.40.89.107:9005/sys/index/auth.do?token=5970dc9990438caba16fa073dd01d1b5f68b5fe8ec1d22835f5c9f324bb5e7dd')
        }
      }else {
        this.$emit('change',obj)
      }
    }
  }
}
</script>

<style scoped lang="less">
/deep/.el-input__inner{
  border: 1px solid #11B0F9;
  background-color: rgba(255,255,255,0);
  width: 300px!important;
  color: #FFFFFF!important;
}
@media screen and (min-width: 1700px) and (max-width: 1900px){
  /deep/.el-input__inner{
    border: 1px solid #11B0F9;
    background-color: rgba(255,255,255,0);
    width: 210px!important;
    color: #FFFFFF!important;
  }
}
@media screen and (min-width: 1500px) and (max-width: 1700px){
  /deep/.el-input__inner{
    border: 1px solid #11B0F9;
    background-color: rgba(255,255,255,0);
    width: 150px!important;
    color: #FFFFFF!important;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1500px){
  /deep/.el-input__inner{
    border: 1px solid #11B0F9;
    background-color: rgba(255,255,255,0);
    width: 120px!important;
    color: #FFFFFF!important;
  }
}
/deep/ .el-tree {
  background-color: #012441;
  color: #11b0f9;
}

/deep/ .el-tree-node__content {
  height: 36px;
}

/deep/ .el-tree-node__content {
  background-color: #012441;
}

/deep/ .el-tree-node__expand-icon {
  color: #11b0f9;
}

/deep/ .el-tree-node__expand-icon.is-leaf {
  color: transparent;
}

/deep/ .el-tree-node:focus > .el-tree-node__content {
  background-color: #00E5FF;
  color: #FFFFFF;
}

/deep/ .el-tree-node.is-current > .el-tree-node__content {
  background-color: #00E5FF;
  color: #FFFFFF;
}

.departmentBox {
  .searchBox{
    width: 100%;
    display: flex;
    justify-content: center;
    margin-bottom: 15px;
    .kernel{
      display: flex;
      .inputBox{

      }
      .searchButton{
        width: 68px;
        height: 38px;
        background-color: #27BCE6;
        border-radius: 3px;
        font-weight: bold;
        color: #FEFFFF;
        font-size: 18px;
        text-align: center;
        line-height: 38px;
        letter-spacing: 3px;
        margin-left: 25px;
        cursor: pointer;
      }
    }
  }
  .firstBox {
    display: flex;

    .circle {
      width: 14px;
      height: 14px;
      background: #11B0F9;
      border-radius: 50%;
      margin-top: 7px;
      margin-right: 10px;
    }

    .text {
      font-size: 21px;
      font-weight: 500;
      color: #11B0F9;
      letter-spacing: 2px;
    }
  }

  .secondBox {
    margin-top: 15px;
  }
}
@media screen and (min-width: 1200px) and (max-width: 1500px){
  .departmentBox {
    .searchBox{
      width: 100%;
      display: flex;
      justify-content: center;
      margin-bottom: 15px;
      .kernel{
        display: flex;
        .inputBox{

        }
        .searchButton{
          width: 68px;
          height: 38px;
          background-color: #27BCE6;
          border-radius: 3px;
          font-weight: bold;
          color: #FEFFFF;
          font-size: 18px;
          text-align: center;
          line-height: 38px;
          letter-spacing: 3px;
          margin-left: 15px;
          cursor: pointer;
        }
      }
    }
    .firstBox {
      display: flex;

      .circle {
        width: 14px;
        height: 14px;
        background: #11B0F9;
        border-radius: 50%;
        margin-top: 7px;
        margin-right: 10px;
      }

      .text {
        font-size: 21px;
        font-weight: 500;
        color: #11B0F9;
        letter-spacing: 2px;
      }
    }

    .secondBox {
      margin-top: 15px;
    }
  }
}
</style>
